export const INTERVAL_RATE = 300;
export default INTERVAL_RATE;
